import React from "react";
import ReactDOM from "react-dom";
//
import cssText from "bundle-text:./style.css";
//
import App from "./App";

document.addEventListener("DOMContentLoaded", function () {
	const element = document.getElementById("hb-admin");
	if (typeof element !== "undefined" && element !== null) {
		// inject <style> tag
		const style = document.createElement("style");
		style.textContent = cssText;
		document.body.appendChild(style);
		// render
		ReactDOM.render(<App />, element);
	}
});
